import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/419bcc41-8f35-407d-bf53-cba158dc2238.png" 
              alt="ESCRITORIO BENDER LTDA Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className={`text-xl font-bold transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              ESCRITORIO BENDER
            </span>
          </div>

          <div className="flex items-center gap-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('vpn-service')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              VPN Service
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-purple-600' : 'text-white hover:text-purple-300'
              }`}
            >
              Contact
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
